// Public-facing Privacy Policy route.
//
// The canonical Privacy Policy is hosted on Termly and served at
// https://tournyflex.com/privacy. This route exists so links inside
// the app (signup form, login page, ToS footer) using the relative
// href="/privacy" don't fall through to the login page — that would
// break Twilio A2P 10DLC campaign review, since reviewers hit /privacy
// anonymously and must reach the actual policy.
//
// A hard redirect keeps the single source of truth on Termly and
// avoids having to embed / mirror the policy in this repo. Uses
// location.replace so the app URL doesn't clutter the user's back
// stack.

import { useEffect } from 'react'

const CANONICAL = 'https://tournyflex.com/privacy'

export default function PrivacyPage() {
  useEffect(() => {
    // Redirect on mount. Any bots / no-JS scrapers see the meta refresh
    // fallback below.
    window.location.replace(CANONICAL)
  }, [])
  return (
    <div style={styles.page}>
      {/* Meta refresh as a defense-in-depth fallback for no-JS clients
          (e.g. some review bots). React can't render a real <meta> tag
          from a component body, so we use a plain link + copy so the
          reviewer still lands on the policy manually. */}
      <p style={styles.para}>
        Redirecting to the TournyFlex Privacy Policy…
      </p>
      <p style={styles.para}>
        If you are not redirected automatically, please visit{' '}
        <a href={CANONICAL} style={styles.link}>
          {CANONICAL}
        </a>
        .
      </p>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0B1426',
    color: '#F5F1E8',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    textAlign: 'center',
  },
  para: { margin: '8px 0', fontSize: 15, lineHeight: 1.6 },
  link: { color: '#D4B97A', textDecoration: 'underline' },
}
